/**
 * @desc 监听页面 resize
 * @date 2019-08-29
 * @author Kody
 */
import { useEffect, useState } from 'react';
import { $window } from '@umu/umu-dom';
import { useDebounce } from './useDebounce';

export const useBodyResize = (callback?: (width: number) => void) => {
    const [width, setWidth] = useState(document.body.clientWidth);
    const body = document.body || document.documentElement;
    const onResize = useDebounce(
        () => {
            setWidth(body.clientWidth);
            if (callback) {
                callback(body.clientWidth);
            }
        },
        500,
        [width]
    );
    useEffect(() => {
        $window.addEventListener('resize', onResize);
        return () => {
            $window.removeEventListener('resize', onResize);
        };
    }, []);
    return width;
};
